export const enum ActivitySelectionModalType {
  None = 'none',
  PaxSelector = 'paxSelector',
  MobileFiltersModal = 'mobileFiltersModal',
  WhyWeSuggest = 'whyWeSuggest',
}
